import { cn } from '@virginexperiencedays/tailwind';

import type { CSSProperties, HTMLAttributes } from 'react';

export type PromoCardProps = HTMLAttributes<HTMLDivElement> & {
  promo?: 'black-friday' | 'cyber-monday';
};

export const PromoCard = ({ promo, className, children, ...rest }: PromoCardProps) => {
  const theme = {
    'black-friday': 'var(--promo-bf)',
    'cyber-monday': 'var(--promo-cm)',
  };

  return (
    <div
      className={cn('shadow-neon rounded border-2 border-white p-4', className)}
      style={
        theme?.[promo]
          ? ({
              '--neon-shadow': theme[promo],
            } as CSSProperties)
          : {}
      }
      {...rest}
    >
      {children}
    </div>
  );
};

export const PromoCardText = ({
  className,
  children,
  ...rest
}: HTMLAttributes<HTMLParagraphElement>) => (
  <p
    className={cn('text-onBackground-neutral m-0 text-base/tight md:leading-none', className)}
    {...rest}
  >
    {children}
  </p>
);

export const PromoCardTextHighlight = ({
  className,
  children,
  ...rest
}: HTMLAttributes<HTMLSpanElement>) => (
  <span
    className={cn(
      'text-persistent-text-dark text-md/none rounded bg-white p-1 font-extrabold md:text-lg/none',
      className
    )}
    {...rest}
  >
    {children}
  </span>
);

export const PromoCardTitle = ({
  className,
  children,
  ...rest
}: HTMLAttributes<HTMLSpanElement>) => (
  <span
    className={cn('inline-block text-xl/tight font-bold uppercase tracking-wider', className)}
    {...rest}
  >
    {children}
  </span>
);
